import clearResults from '../actions/clearResults';
import addResults from '../actions/addResults';
import executeSearch from '../actions/executeSearch';
import selectInlineSearchAction from '../actions/selectInlineSearchAction';
import setCachedDoradoSearchResults from '../actions/setCachedDoradoSearchResults';
import updateCurrentSearchCorrelationId from '../actions/updateCurrentSearchCorrelationId';
import executeDoradoSearch from '../service/executeDoradoSearch';
import store from '../store/cortanaComposeStore';
import DoradoSearchResult from '../store/schema/DoradoSearchResult';
import getDoradoSearchResultsFromJson from '../utils/getDoradoSearchResultsFromJson';
import { getGuid } from 'owa-guid';
import { trace } from 'owa-trace';
import { orchestrator } from 'satcheljs';
import CortanaComposeResult, {
    CortanaComposeResultType,
    CortanaComposeResultSection,
} from '../store/schema/CortanaComposeResult';

export default orchestrator(executeSearch, async actionMessage => {
    searchDoradoIfNecessary(actionMessage.queryString, actionMessage.messageBody);
});

const SEARCH_DELAY = 500; // half a second

let currentSearchTimer: NodeJS.Timer;

async function searchDoradoIfNecessary(queryString: string, messageBody: string) {
    clearResults();
    if (!store.cachedDoradoSearchResults) {
        addResults(CortanaComposeResultSection.dorado, [
            {
                onSelected: null,
                selectable: false,
                type: CortanaComposeResultType.searching,
            },
        ]);

        if (currentSearchTimer) {
            clearTimeout(currentSearchTimer);
            currentSearchTimer = null;
        }

        currentSearchTimer = setTimeout(async () => {
            const correlationId = getGuid();
            updateCurrentSearchCorrelationId(correlationId);

            // TODO: re-add messageBody to the search
            const doradoSearchResults = await executeDoradoSearch('', correlationId);
            setCachedDoradoSearchResults(doradoSearchResults);
            updateSearchUIBasedOnCachedValue(queryString);
            currentSearchTimer = null;
        }, SEARCH_DELAY);
    } else {
        updateSearchUIBasedOnCachedValue(queryString);
    }
}

function updateSearchUIBasedOnCachedValue(queryString: string) {
    if (store.cachedDoradoSearchResults) {
        addDoradoSearchResultsToInlineSearch(store.cachedDoradoSearchResults, queryString);
    } else {
        trace.info('[executeDoradoSearchOrchestrator] executeDoradoSearch returned no results');
        addNoResultsForDorado();
    }
}

function addDoradoSearchResultsToInlineSearch(doradoSearchResponseJson: any, queryString: string) {
    try {
        const results = getDoradoSearchResultsFromJson(doradoSearchResponseJson);
        const filteredResults = filterResults(results, queryString);

        if (filteredResults && filteredResults.length > 0) {
            addResults(
                CortanaComposeResultSection.dorado,
                filteredResults.map(result => {
                    return {
                        onSelected: onDoradoResultSelected,
                        selectable: true,
                        type: CortanaComposeResultType.doradoResult,
                        resultObject: result,
                    };
                })
            );
        } else {
            addNoResultsForDorado();
        }
    } catch (error) {
        trace.info(
            '[CortanaComposeDataProvider] addDoradoSearchResultsToInlineSearch: exception when parsing results: ' +
                error.message
        );
    }
}

function onDoradoResultSelected(result: CortanaComposeResult) {
    if (store.viewState.pluginCallbacks.dismissSuggesting) {
        store.viewState.pluginCallbacks.dismissSuggesting();
    }
    selectInlineSearchAction(result);
}

function filterResults(results: DoradoSearchResult[], queryString: string): DoradoSearchResult[] {
    return results.filter(value => {
        const doradoRuntimeResult = value as DoradoSearchResult;
        return (
            doradoRuntimeResult.title.toLowerCase().indexOf(queryString.toLowerCase()) >= 0 ||
            doradoRuntimeResult.subTitle.toLowerCase().indexOf(queryString.toLowerCase()) >= 0
        );
    });
}

function addNoResultsForDorado() {
    addResults(CortanaComposeResultSection.dorado, [
        {
            onSelected: null,
            selectable: false,
            type: CortanaComposeResultType.noResults,
        },
    ]);
}
